import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { canEdit, getUserType } from "../permissions";
import API_BASE from "../config";

const EditBooking = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const booking = location.state?.booking;
  const userType = getUserType();
  const allowEdit = canEdit(userType, "bookings");

  const [form, setForm] = useState({
    id: "",
    booking_id: "",
    customer_name: "",
    cust_phone: "",
    unit: "",
    unit2: "",
    project_name: "",
    project_id: "",
    agreement_type: "",
    plan_type: "",
    sale_type: "",
    buildarea: "",
    sale_price: "",
    land_cost: "",
    construction_cost: "",
    total_saleprice: "",
    payment_source: "",
    loan_amount: "",
    self_pay: "",
    sale_gst: "",
    r_status: "",
    loan_status: "",
    comment: "",
    date: "",
  });

  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");
  const [projects, setProjects] = useState([]);

  // Pre-fill form from passed booking data
  useEffect(() => {
    if (!allowEdit) { navigate("/dashboard/bookings"); return; }
    if (!booking) {
      navigate("/dashboard/bookings");
      return;
    }
    setForm({
      id: booking.id || "",
      booking_id: booking.booking_id || "",
      customer_name: booking.customer_name || "",
      cust_phone: booking.cust_phone || "",
      unit: booking.unit || "",
      unit2: booking.unit2 || "",
      project_name: booking.project_name || "",
      project_id: booking.project_id || "",
      agreement_type: booking.agreement_type || "",
      plan_type: booking.plan_type || "",
      sale_type: booking.sale_type || "",
      buildarea: booking.buildarea || "",
      sale_price: booking.sale_price || "",
      land_cost: booking.land_cost || "",
      construction_cost: booking.construction_cost || "",
      total_saleprice: booking.total_saleprice || "",
      payment_source: booking.payment_source || "",
      loan_amount: booking.loan_amount || "",
      self_pay: booking.self_pay || "",
      sale_gst: booking.sale_gst || "",
      r_status: booking.r_status || "",
      loan_status: booking.loan_status || "",
      comment: booking.comment || "",
      date: booking.date || "",
    });

    // Fetch projects table
    fetch(`${API_BASE}/api/allrows`, {
      method: "POST",
      headers: {
        Authorization: "1",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        token: "3232",
        table: "projects",
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (Array.isArray(json.data)) {
          setProjects(json.data);
        }
      })
      .catch((err) => console.error("Projects API Error:", err));
  }, [booking, navigate, allowEdit]);

  if (!allowEdit) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    if (name === "project_name") {
      const selectedProject = projects.find((p) => p.shortform === value);
      setForm((prev) => ({
        ...prev,
        project_name: value,
        project_id: selectedProject ? selectedProject.id : "",
      }));
    } else if (name === "payment_source" && value === "100% Self") {
      setForm((prev) => ({
        ...prev,
        payment_source: value,
        loan_amount: "0",
        loan_status: "",
      }));
    } else {
      setForm((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSaving(true);
    setError("");
    setSuccess("");

    const formData = new URLSearchParams();
    Object.keys(form).forEach((key) => {
      if (key !== "id") formData.append(key, form[key]);
    });

    fetch(`${API_BASE}/api/updatedatas`, {
      method: "POST",
      headers: {
        Authorization: "1",
        Table: "bookings",
        Id: form.id,
      },
      body: formData,
    })
      .then((res) => res.json())
      .then((json) => {
        setSaving(false);
        if (json.status == true) {
          setSuccess("Booking updated successfully!");
          setTimeout(() => navigate("/dashboard/bookings"), 1500);
        } else {
          setError(json.message || "Failed to update booking.");
        }
      })
      .catch((err) => {
        setSaving(false);
        console.error("Update Error:", err);
        setError("An error occurred while updating. Please try again.");
      });
  };
  const isAfterSales = userType?.toLowerCase() === "after sales";

  return (
    <>
      <style>
        {`
        .eb-page {
          max-width: 900px;
          margin: 0 auto;
        }

        .eb-header {
          display: flex;
          align-items: center;
          gap: 14px;
          margin-bottom: 24px;
        }

        .eb-back-btn {
          padding: 8px 16px;
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          color: #334155;
          cursor: pointer;
          font-size: 14px;
          font-weight: 500;
          font-family: 'Inter', sans-serif;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .eb-back-btn:hover {
          background: #f1f5f9;
          border-color: #cbd5e1;
        }

        .eb-title {
          font-size: 22px;
          font-weight: 700;
          color: #0f172a;
        }

        .eb-booking-id {
          font-size: 13px;
          color: #64748b;
          font-weight: 400;
        }

        .eb-card {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 16px;
          padding: 28px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.04);
        }

        .eb-section-title {
          font-size: 14px;
          font-weight: 600;
          color: #0f172a;
          margin-bottom: 16px;
          padding-bottom: 10px;
          border-bottom: 1px solid #f1f5f9;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .eb-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 28px;
        }

        .eb-grid-3 {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 16px;
          margin-bottom: 28px;
        }

        .eb-field {
          display: flex;
          flex-direction: column;
          gap: 6px;
        }

        .eb-field.full {
          grid-column: 1 / -1;
        }

        .eb-field label {
          font-size: 12px;
          font-weight: 600;
          color: #64748b;
          text-transform: uppercase;
          letter-spacing: 0.4px;
        }

        .eb-field input,
        .eb-field select,
        .eb-field textarea {
          padding: 11px 14px;
          border-radius: 10px;
          border: 1px solid #e2e8f0;
          font-size: 14px;
          font-family: 'Inter', sans-serif;
          color: #1e293b;
          background: #f8fafc;
          outline: none;
          transition: all 0.2s;
        }

        .eb-field input:focus,
        .eb-field select:focus,
        .eb-field textarea:focus {
          border-color: #93c5fd;
          box-shadow: 0 0 0 3px rgba(59,130,246,0.08);
          background: #fff;
        }

        .eb-field input:disabled {
          background: #f1f5f9;
          color: #94a3b8;
          cursor: not-allowed;
        }

        .eb-field textarea {
          min-height: 80px;
          resize: vertical;
        }

        .eb-actions {
          display: flex;
          gap: 12px;
          margin-top: 8px;
          padding-top: 20px;
          border-top: 1px solid #f1f5f9;
        }

        .eb-save-btn {
          padding: 12px 28px;
          background: linear-gradient(135deg, #2563eb, #3b82f6);
          color: #fff;
          border: none;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 600;
          cursor: pointer;
          font-family: 'Inter', sans-serif;
          transition: all 0.2s;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .eb-save-btn:hover:not(:disabled) {
          background: linear-gradient(135deg, #1d4ed8, #2563eb);
          box-shadow: 0 4px 14px rgba(37,99,235,0.3);
          transform: translateY(-1px);
        }

        .eb-save-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .eb-cancel-btn {
          padding: 12px 24px;
          background: #f8fafc;
          color: #64748b;
          border: 1px solid #e2e8f0;
          border-radius: 10px;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          font-family: 'Inter', sans-serif;
          transition: all 0.2s;
        }

        .eb-cancel-btn:hover {
          background: #f1f5f9;
          color: #334155;
        }

        .eb-spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(255,255,255,0.3);
          border-top-color: #fff;
          border-radius: 50%;
          animation: eb-spin 0.6s linear infinite;
        }

        @keyframes eb-spin {
          to { transform: rotate(360deg); }
        }

        .eb-alert {
          padding: 12px 16px;
          border-radius: 10px;
          font-size: 13px;
          margin-bottom: 20px;
          font-weight: 500;
        }

        .eb-alert-success {
          background: #ecfdf5;
          color: #059669;
          border: 1px solid #a7f3d0;
        }

        .eb-alert-error {
          background: #fef2f2;
          color: #dc2626;
          border: 1px solid #fecaca;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .eb-grid, .eb-grid-3 {
            grid-template-columns: 1fr;
          }

          .eb-card {
            padding: 20px;
          }

          .eb-actions {
            flex-direction: column;
          }
        }
        `}
      </style>

      <div className="eb-page">
        {/* Header */}
        <div className="eb-header">
          <button className="eb-back-btn" onClick={() => navigate("/dashboard/bookings")}>
            ← Back
          </button>
          <div>
            <div className="eb-title">Edit Booking</div>
            <div className="eb-booking-id">Booking ID: {form.booking_id}</div>
          </div>
        </div>

        {/* Alerts */}
        {success && <div className="eb-alert eb-alert-success">✅ {success}</div>}
        {error && <div className="eb-alert eb-alert-error">⚠️ {error}</div>}

        {/* Form */}
        <form className="eb-card" onSubmit={handleSubmit}>
          {/* Customer Details */}
          <div className="eb-section-title">👤 Customer Details</div>
          <div className="eb-grid">
            <div className="eb-field">
              <label>Customer Name</label>
              <input name="customer_name" value={form.customer_name} onChange={handleChange} required />
            </div>
            <div className="eb-field">
              <label>Phone Number</label>
              <input name="cust_phone" value={form.cust_phone} onChange={handleChange} />
            </div>
          </div>

          {/* Property Details */}
          <div className="eb-section-title">🏠 Property Details {isAfterSales && "(Locked for After Sales)"}</div>
          <div className="eb-grid-3">
            <div className="eb-field">
              <label>Project</label>
              <select name="project_name" value={form.project_name} onChange={handleChange} disabled={isAfterSales}>
                <option value="">Select Project</option>
                {projects.map((p) => (
                  <option key={p.id} value={p.shortform}>
                    {p.name || p.shortform} {p.shortform && `(${p.shortform})`}
                  </option>
                ))}
              </select>
            </div>
            <div className="eb-field">
              <label>Unit</label>
              <input name="unit" value={form.unit} onChange={handleChange} disabled={isAfterSales} />
            </div>
            <div className="eb-field">
              <label>Additional Units</label>
              <input name="unit2" value={form.unit2} onChange={handleChange} placeholder="e.g. 85,86" disabled={isAfterSales} />
            </div>
            <div className="eb-field">
              <label>Agreement Type</label>
              <select name="agreement_type" value={form.agreement_type} onChange={handleChange} disabled={isAfterSales}>
                <option value="">Select</option>
                <option value="Unit">Unit</option>
                <option value="P+C">P+C</option>
              </select>
            </div>
            <div className="eb-field">
              <label>Plan Type</label>
              <select name="plan_type" value={form.plan_type} onChange={handleChange} disabled={isAfterSales}>
                <option value="">Select</option>
                <option value="Standard">Standard</option>
                <option value="Customize">Customize</option>
              </select>
            </div>
            <div className="eb-field">
              <label>Sale Type</label>
              <select name="sale_type" value={form.sale_type} onChange={handleChange} disabled={isAfterSales}>
                <option value="">Select</option>
                <option value="Plots/ Flats/ Shop">Plots/ Flats/ Shop</option>
                <option value="Singlex">Singlex</option>
                <option value="Duplex">Duplex</option>
              </select>
            </div>
            <div className="eb-field">
              <label>Build Area (sq ft)</label>
              <input name="buildarea" value={form.buildarea} onChange={handleChange} disabled={isAfterSales} />
            </div>
          </div>

          {/* Financial Details */}
          <div className="eb-section-title">💰 Financial Details</div>
          <div className="eb-grid-3">
            <div className="eb-field">
              <label>Sale Price (₹)</label>
              <input name="sale_price" type="number" value={form.sale_price} onChange={handleChange} />
            </div>
            <div className="eb-field">
              <label>Land Cost (₹)</label>
              <input name="land_cost" type="number" value={form.land_cost} onChange={handleChange} />
            </div>
            <div className="eb-field">
              <label>Construction Cost (₹)</label>
              <input name="construction_cost" type="number" value={form.construction_cost} onChange={handleChange} />
            </div>
            <div className="eb-field">
              <label>Total Sale Price (₹)</label>
              <input name="total_saleprice" type="number" value={form.total_saleprice} onChange={handleChange} />
            </div>
            <div className="eb-field">
              <label>GST (₹)</label>
              <input name="sale_gst" type="number" value={form.sale_gst} onChange={handleChange} />
            </div>
          </div>

          {/* Payment & Status */}
          <div className="eb-section-title">📋 Payment & Status</div>
          <div className="eb-grid-3">
            <div className="eb-field">
              <label>Payment Source</label>
              <select name="payment_source" value={form.payment_source} onChange={handleChange}>
                <option value="">Select</option>
                <option value="100% Self">100% Self</option>
                <option value="Self + Bank Loan">Self + Bank Loan</option>
              </select>
            </div>
            <div className="eb-field">
              <label>Loan Amount (₹)</label>
              <input 
                name="loan_amount" 
                type="number" 
                value={form.loan_amount} 
                onChange={handleChange} 
                disabled={form.payment_source === "100% Self"}
              />
            </div>
            <div className="eb-field">
              <label>Self Pay (₹)</label>
              <input name="self_pay" type="number" value={form.self_pay} onChange={handleChange} />
            </div>
            <div className="eb-field">
              <label>Registry Status</label>
              <select name="r_status" value={form.r_status} onChange={handleChange}>
                <option value="">Select</option>
                <option value="Open">Open</option>
                <option value="Schedule">Schedule</option>
                <option value="Done">Done</option>
              </select>
            </div>
            <div className="eb-field">
              <label>Loan Status</label>
              <select 
                name="loan_status" 
                value={form.loan_status} 
                onChange={handleChange}
                disabled={form.payment_source === "100% Self"}
              >
                <option value="">Select</option>
                <option value="Applied">Applied</option>
                <option value="Proposed">Proposed</option>
                <option value="Sanctioned">Sanctioned</option>
              </select>
            </div>
            <div className="eb-field">
              <label>Date</label>
              <input name="date" value={form.date} onChange={handleChange} />
            </div>
          </div>

          {/* Comment */}
          <div className="eb-section-title">💬 Notes</div>
          <div className="eb-field full" style={{ marginBottom: 20 }}>
            <label>Comment</label>
            <textarea name="comment" value={form.comment} onChange={handleChange} placeholder="Add notes..." />
          </div>

          {/* Actions */}
          <div className="eb-actions">
            <button type="submit" className="eb-save-btn" disabled={saving}>
              {saving && <span className="eb-spinner" />}
              {saving ? "Saving..." : "💾 Save Changes"}
            </button>
            <button type="button" className="eb-cancel-btn" onClick={() => navigate("/dashboard/bookings")}>
              Cancel
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default EditBooking;
